import { render, staticRenderFns } from "./ConsultarOfertas.vue?vue&type=template&id=d24e2068&scoped=true"
import script from "./ConsultarOfertas.vue?vue&type=script&lang=js"
export * from "./ConsultarOfertas.vue?vue&type=script&lang=js"
import style0 from "./ConsultarOfertas.vue?vue&type=style&index=0&id=d24e2068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24e2068",
  null
  
)

export default component.exports